module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point01/th_02-e742f544d017e298ef5d2e8016e1f381.jpg";